import React, {useEffect, useState} from 'react';
import {Alert, Button, Form} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {useStores} from "../../../stores/Context";
import axios from "axios";
import BtnAction from "../../../boiteAOutils/BtnAction";
import BtnSvg from "../../../boiteAOutils/BtnSvg";

const ParametresGeneral = () => {
    const {ent} = useParams();
    const {widgetStore} = useStores();
    const [afficherInputYdos, setAfficherInputYdos] = useState(false);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + widgetStore.getCookie("current_apiToken");

    const [infosTotem, setInfosTotem] = useState('');
    const [message, setMessage] = useState(false);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/totem/' + widgetStore.idTotem).then((res) => {
            setInfosTotem(res.data);
        })
    }, []);

    const handleUpdateGeneral = () => {
        console.log("handleUpdate", infosTotem.tot_filtre_donnees);
        axios.post(process.env.REACT_APP_API_URL + '/api/updateInfosTotem', {
            id: widgetStore.idTotem,
            tot_nom: infosTotem.tot_nom,
            tot_description: infosTotem.tot_description,
            tot_batiment: infosTotem.tot_batiment,
            tot_service: infosTotem.tot_service,
            tot_activite: infosTotem.tot_activite,
            tot_filtre_donnees: infosTotem.tot_filtre_donnees,
        }).then(() => {
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
            }, 5000);
        })
    }

    const handleClickAjouterPrefixeYdos = () => {
        setAfficherInputYdos(true);
    };

    const handleClearPrefixeYdos = () => {
        setAfficherInputYdos(false);

        // Mettre à jour immédiatement en base avec la valeur null
        axios.post(process.env.REACT_APP_API_URL + '/api/updateInfosTotem', {
            id: widgetStore.idTotem,
            tot_nom: infosTotem.tot_nom,
            tot_description: infosTotem.tot_description,
            tot_batiment: infosTotem.tot_batiment,
            tot_service: infosTotem.tot_service,
            tot_activite: infosTotem.tot_activite,
            tot_filtre_donnees: null, // Envoie null pour effacer en base
        }).then(() => {
            // Mettre à jour l’état local une fois l’API confirmée
            setInfosTotem({
                ...infosTotem,
                tot_filtre_donnees: null
            });
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
            }, 5000);
        });
    };

    return (
        <div>

            <h1 className={"parametreTitre1"}>L'écran <span
                className={"parametreTitreName"}>{infosTotem.tot_nom ?? ''}</span></h1>

            <div className={"parametreContentTitre"}>
                <h4 className={"parametreTitre4"}>Paramètres Généraux</h4>
            </div>

            <div className={"parametreContentGeneraux"}>
                <label className={"parametreTotemLabel"}>Nom :</label>
                <input className={"parametreInput"} type={"text"}
                       value={infosTotem.tot_nom ?? ''}
                       onChange={(e) => setInfosTotem({...infosTotem, tot_nom: e.target.value})}
                       onBlur={handleUpdateGeneral}
                />

                <label className={"parametreTotemLabel"}>Description :</label>
                <textarea className={"parametreInputLong"}
                          value={infosTotem.tot_description ?? ''}
                          onChange={(e) => setInfosTotem({...infosTotem, tot_description: e.target.value})}
                          onBlur={handleUpdateGeneral}
                />


                {(afficherInputYdos || infosTotem.tot_filtre_donnees) ? (
                    <>
                        <label className={"parametreTotemLabel"}>Préfixe YDOS :</label>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <input className={"parametreInput"} type={"text"}
                                   value={infosTotem.tot_filtre_donnees ?? ''}
                                   onChange={(e) => setInfosTotem({
                                       ...infosTotem,
                                       tot_filtre_donnees: e.target.value
                                   })}
                                   onBlur={handleUpdateGeneral}
                            />
                            <BtnSvg svg={'corbeille'} onClick={handleClearPrefixeYdos}/>
                        </div>
                    </>
                ) : (
                    <BtnAction onClick={handleClickAjouterPrefixeYdos}>+ Ajouter un préfixe YDOS</BtnAction>
                )}


            </div>
        </div>
    );
};

export default ParametresGeneral;